import React, { Component } from "react"
import { Arwes, Button, Header, Frame as FrameC } from "arwes"
import Icon from "@mdi/react"
import { mdiChemicalWeapon } from "@mdi/js"
import styled from "styled-components"
import { connect } from "react-redux"
import get from "lodash.get"
import {
  deleteUser,
  getUserInformation,
  getUsers,
  signOut
} from "./redux/reducers"
import {
  ContentColumn,
  PageBlock,
  PageOffset
} from "../../common/styled/Page"
import { MarginTop } from "../../common/styled/MarginTop"

const GUEST_ID = "5c92b9bf934bf41012beb524"

const ButtonBar = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 50px;
  padding-bottom: 30px;

  @media (max-width: 600px) {
    padding-top: 24px;
    padding-bottom: 20px;
  }
`

const HeaderBlock = styled.div`
  padding: 20px 0;

  h1 {
    margin: 0;
    overflow-wrap: anywhere;
    text-align: center;
  }
`

const UserName = styled.div`
  display: flex;
  justify-content: center;
  font-size: 32px;
  min-width: 0;
  overflow-wrap: anywhere;

  @media (max-width: 600px) {
    font-size: 24px;
  }
`

const ConfirmationPanel = styled.div`
  margin-top: 40px;

  @media (max-width: 600px) {
    margin-top: 24px;
  }
`

const WarningMessage = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px 16px 0;
  text-align: center;
`

const DismissBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 30px;

  @media (max-width: 600px) {
    margin: 20px 16px;
  }
`

class DeleteUser extends Component {
  state = {
    show: false,
    confirm: false,
    warning: false,
    deleting: false,
    error: ""
  }
  componentDidMount() {
    const routeId = get(this.props, "match.params.userId")
    const loadedId = get(this.props, "user.loadedUser._id")
    if (routeId && String(routeId) !== String(loadedId)) {
      this.props.getUserInformation(routeId)
    }
    setTimeout(() => {
      this.setState({
        show: true
      })
    }, 1000)
  }

  handleDelete = async () => {
    const { user } = this.props
    const targetId = get(this.props, "match.params.userId")
    const viewerId = get(user, "loaded.user._id")

    if (targetId === GUEST_ID) {
      this.setState({
        confirm: false,
        warning: true
      })
      return
    }

    const deletingSelf = String(targetId) === String(viewerId)
    const rosterPage = get(user, "loadedUsers.page", 1)
    const rosterUsers = get(user, "loadedUsers.users", [])
    this.setState({ deleting: true, error: "" })
    const result = await this.props.deleteUser(targetId, { deletingSelf })

    if (!result || !result.ok) {
      this.setState({
        deleting: false,
        confirm: false,
        error: (result && result.error) || "Unable to delete user"
      })
      return
    }

    if (deletingSelf) {
      await this.props.signOut()
      return
    }

    this.props.history.replace("/users")
    const deletedOnlyRosterUser =
      Array.isArray(rosterUsers) &&
      rosterUsers.length === 1 &&
      String(rosterUsers[0]._id) === String(targetId)
    const nextPage =
      rosterPage > 1 && deletedOnlyRosterUser
        ? rosterPage - 1
        : rosterPage
    this.props.getUsers(nextPage, 12)
  }

  render() {
    const { isExpanded, user } = this.props
    const routeId = get(this.props, "match.params.userId")
    const viewerId = get(user, "loaded.user._id")
    const loadedUserId = get(user, "loadedUser._id")
    const getName =
      (String(routeId) === String(loadedUserId) &&
        get(user, "loadedUser.name")) ||
      (routeId === viewerId ? get(user, "loaded.user.name") : "")
    return (
      <Arwes>
        <PageOffset isExpanded={isExpanded}>
          <MarginTop />
          <ContentColumn maxWidth={700}>
            <PageBlock>
              <HeaderBlock>
                <Header animate>
                  <h1>Delete Profile</h1>
                </Header>
              </HeaderBlock>
              <FrameC
                show={this.state.show}
                animate={true}
                level={3}
                corners={4}
                layer="success"
              >
                <UserName>{getName}</UserName>
              </FrameC>
              <ButtonBar>
                <Button
                  animate
                  layer="alert"
                  disabled={this.state.deleting}
                  onClick={() => this.setState({ confirm: true })}
                >
                  <Icon path={mdiChemicalWeapon} size={0.5} color="red" spin />{" "}
                  Delete Profile
                </Button>
              </ButtonBar>
              {this.state.error && (
                <FrameC animate level={3} corners={4} layer="alert">
                  <WarningMessage role="alert">
                    {this.state.error}
                  </WarningMessage>
                </FrameC>
              )}
              {this.state.warning && (
                <FrameC
                  animate={true}
                  level={3}
                  corners={4}
                  layer="alert"
                >
                  <WarningMessage>
                    You cannot delete our Guest User!
                  </WarningMessage>
                  <DismissBar>
                    <Button
                      animate
                      layer="success"
                      onClick={() => this.setState({ warning: false })}
                    >
                      <Icon
                        path={mdiChemicalWeapon}
                        size={0.5}
                        color="green"
                        spin
                      />{" "}
                      Dismiss
                    </Button>
                  </DismissBar>
                </FrameC>
              )}
              {this.state.confirm && (
                <ConfirmationPanel>
                  <FrameC
                    show={this.state.show}
                    animate={true}
                    level={3}
                    corners={4}
                    layer="alert"
                  >
                    <WarningMessage>Are you sure?</WarningMessage>
                    <ButtonBar>
                      <Button
                        animate
                        layer="alert"
                        disabled={this.state.deleting}
                        onClick={this.handleDelete}
                      >
                        <Icon
                          path={mdiChemicalWeapon}
                          size={0.5}
                          color="red"
                          spin
                        />{" "}
                        {this.state.deleting ? "Deleting…" : "Delete"}
                      </Button>
                      <Button
                        animate
                        layer="success"
                        disabled={this.state.deleting}
                        onClick={() => this.setState({ confirm: false })}
                      >
                        <Icon
                          path={mdiChemicalWeapon}
                          size={0.5}
                          color="green"
                          spin
                        />{" "}
                        Cancel
                      </Button>
                    </ButtonBar>
                  </FrameC>
                </ConfirmationPanel>
              )}
            </PageBlock>
          </ContentColumn>
        </PageOffset>
      </Arwes>
    )
  }
}

const mapState = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapState,
  { deleteUser, getUserInformation, getUsers, signOut }
)(DeleteUser)
